import ru from './translation/ru.json';
import kz from './translation/kz.json';
import ch from './translation/ch.json';
import kg from './translation/kg.json';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    ru: {
        translation: ru,
    },
    kz: {
        translation: kz,
    },
    ch: {
        translation: ch,
    },
    kg: {
        translation: kg,
    }
};
i18next.use(initReactI18next).init({
    resources,
    lng: localStorage.getItem('language') || 'ru',
    fallbackLng: 'kz',
    interpolation: {
        escapeValue: false,
    },
});
export default i18next;
